import { render } from "./TheDemandEbusDivisionPayment.vue?vue&type=template&id=35b570d4&scoped=true"
import script from "./TheDemandEbusDivisionPayment.vue?vue&type=script&lang=js"
export * from "./TheDemandEbusDivisionPayment.vue?vue&type=script&lang=js"

import "./TheDemandEbusDivisionPayment.vue?vue&type=style&index=0&id=35b570d4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35b570d4"

export default script